export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/identity.js
// module id = 625
// module chunks = 0